<template>
  <div class="container-fluid p-3"> 
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">MULTAS     {{ "UFVs:"+listado_ufv.monto }} {{ "Fecha:"+formatFecha(getDate(listado_ufv.fecha)) }}</h5>
        <div class="row mt-4">
          <div class="col-md-3"></div>
          <div class="col-md-6 input-group">
            <input
              type="text"
              class="form-control input-sm"
              placeholder="Nombres o Apellidos"
              v-model="parametro"
              @keypress="parametro = parametro.toUpperCase()"
              v-on:keyup.enter="AnalisisbusquedaPersona(parametro)" 
            
            />

            <div class="input-group-append">
              <button
                class="btn btn-info"
                type="button"
                @click="AnalisisbusquedaPersona(parametro)"
               
              >
                Buscar <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div> <br>
        
       <div>
        
                 
            
            <div class="row">
              <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
                <table class="table table-bordered">
                  <tr class="text-center">
                    <th><small class="font-weight-bold">#</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO / DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">FECHA DECLARACIÓN</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">ESTADO</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th> 
                  </tr>
                  <tr v-for="(item, index) in registrosMultados" :key="index">
                    <td class="text-center">
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td>
                      <small>{{ item.per_nombres + " " }}</small>
                      <small>{{ item.per_primer_apellido + " "+ item.per_segundo_apellido}}</small> <br>
                      <small>{{ "Doc:"+item.per_numero_documento }}</small>
                    
                    </td>
                    <td>
                      <small>
                        {{ "F.Inicio:"+formatFecha(getDate(item.fecha_inicio)) }} <br />
                        {{ "F.Fin:"+formatFecha(getDate(item.fecha_fin)) }}
                      </small>
                    </td>
                    
                    <td>
                      <small>{{ item.nombre }}</small>
                    </td>
                    <td><small>{{ item.fecha_reg}}</small></td>
                    <td class="text-center">
                      <span v-if="item.multa == true && item.revisado == 0 && item.pago !== true || item.multa == true && item.revisado == 3 && item.pago !== true" class="badge badge-success">HABILITADO</span>
                      <span v-if="item.multa == false && item.revisado == 0 || item.multa == false && item.revisado == 3" class="badge badge-danger">NO DECLARO</span>
                      <span v-if="item.revisado == 2 || item.revisado == 1" class="badge badge-secondary">DECLARÓ</span>
                      <span v-if="item.pago == true" class="badge badge-primary">CANCELADO</span>
                      
                    </td>
                    
                   <td class="text-center">
                      <span
                              v-if="item.multa !== true && item.revisado == 0 || item.multa !== true && item.revisado == 3 "
                              class="btn btn-outline-danger btn-sm mr-2"
                              title="Sanción"
                              @click="showModal(item)">
                              <i class="fa fa-credit-card"></i>
                            </span>
                      <!--<a v-if="item.multa == true && item.revisado == 0 || item.multa == true && item.revisado == 3 "
                        class="btn btn-outline-primary btn-sm mr-2"
                        title="Descargar"
                        @click="obtenerTalon(item)">
                        <i class="fa fa-file"></i>
                      </a>-->
                      <span
                              v-if="item.multa == true && item.revisado == 0 && item.pago !== true || item.multa == true && item.revisado == 3 && item.pago !== true|| item.multa == true && item.revisado == 1 && item.pago !== true"
                              class="btn btn-outline-primary btn-sm mr-2"
                              title="Sanción"
                              @click="showModal_multa(item)">
                              <i class="fa fa-credit-card"></i>
                            </span>
                      <!--<a v-if="item.multa !== true && item.revisado == 0 || item.multa !== true && item.revisado == 3 "
                        class="btn btn-outline-success btn-sm mr-2"
                        title="Acta de Consignacion"
                        @click="obtenerDocumento(item)"
                        >
                        
                        
                        <i class="fa fa-file"></i>
                      </a>-->
                    </td>
                  </tr>
                </table>
              </div>
            </div>
      </div>

      </div>
    </div>
    <b-modal
      class="modal fade"
      title="SANCIÓN"
      size="xl"
      hide-footer
      ref="modalSancion"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>{{ elegido.per_nombres+" " }}{{ elegido.per_primer_apellido+" " }}{{ elegido.per_segundo_apellido }}</td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ elegido.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Nacionalidad:</th>
                <td>{{ elegido.nombre }}</td>
              </tr>

              <tr v-if="elegido.fecha_inicio">
                <th>Desde:</th>
                <td>{{ formatFecha(getDate(elegido.fecha_inicio)) }}</td>
              </tr>
              <tr v-if="elegido.fecha_fin">
                <th>Hasta:</th>
                <td>{{ formatFecha(getDate(elegido.fecha_fin)) }}</td>
              </tr>          
            </table>
          </div>
          <div class="col-6">
            <div class="alert alert-warning">
              <h5 class="text-dark text-justify">
                Si el ciudadano no declara su dirección en un máximo de dos días calendario, 
                o se verifica que su declaración no es real,
                es sujeto a sanción según art. 37 de la reglamentación de la ley 370.
              </h5>
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Observación de la sanción:</label>
              <textarea
                type="text"
                class="form form-control"
                v-model="elegido.observacion_sancion"
                @keyup="elegido.observacion_sancion = elegido.observacion_sancion.toUpperCase()"
                placeholder="Indique motivos por los cuales se aplicará la sanción"
              ></textarea>
         
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModal" class="btn btn-secondary mr-4">Cerrar</a>
            <button @click="registrarSancion(elegido.id_persona)" :disabled="elegido.observacion_sancion==undefined" class="btn btn-danger">
              APLICAR SANCIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      title="MULTA"
      size="xl"
      hide-footer
      ref="modalMulta"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>{{ elegido.per_nombres+" " }}{{ elegido.per_primer_apellido+" " }}{{ elegido.per_segundo_apellido }}</td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ elegido.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Actualizacion de la UFV:</th>
                <td>{{ listado_ufv.monto }} <br>
                <small>{{ "Fecha:"+formatFecha(getDate(listado_ufv.fecha)) }}</small>
                </td>
                
              </tr>

              <tr >
                <th>Valor Multa en UFVs</th>
                <td>{{ elegido.valor_multa_ufv }}</td>
              </tr>
              <tr>
                <th>Valor Multa en Bs.:</th>
                <td>{{ elegido.valor_multa_bs }}</td>
              </tr>          
            </table>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class=" mr-1">Número Depósito</label>
               
                      <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Ej. 123456789"
                        v-model="elegido.deposito"
                        @keyup="elegido.deposito = elegido.deposito.toUpperCase()"
                      >
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Fecha de Depósito:</label>
              <input 
                        type="date" 
                        class="form-control" 
                        v-model="elegido.fecha_deposito" 
                      >
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModal_multa" class="btn btn-secondary mr-4">Cerrar</a>
            <button @click="registrarMulta(elegido.id_persona)" :disabled="elegido.deposito==undefined" class="btn btn-danger">
              APLICAR SANCIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import moment from "moment";

export default {
  name: "analisisSeguimientoVentanilla",
  components: {
    Loading,
  },
  data() {
    return {
      fecha_deposito: new moment().format("YYYY-MM-DD"),
      fecha_ufv: new Date(),
      elegido: {},
      listado_ufv: {
        monto:'',
       
      },
      id_persona_multa: {},
      personas_domicilio: {},
      persona:{},
      parametro: "",
      ufv:2.37,
      multa:true,
      pago:true,
      totalpagar:100,
      valor_multa_bs:'',
      valor_multa_ufv:100,
      registrosMultados: [],
      registrosVencidos: [],
      registrosEncontrados: [],
      registrosEncontradosHotel: [],
      registrosEncontradosAereo: [],
      registrosEncontradosTerrestre: [],
      registrosEncontradosTurismo: [],
      registrosEncontradosEducativa: [],
      registrosEncontradosNocturna: [],
      url: process.env.VUE_APP_URL + '/documentoTalonControl/',
      url_ac: process.env.VUE_APP_URL + '/documentoConsignacion/',
      cargando: false,
      registrosDeclarados: false,
      registrosHotel: false,
      registrosAviacion: false,
      registrosTerrestre: false,
      registrosTurismo: false,
      registrosEstudiante: false,
      registrosNocturno: false,
      tituloDeclaracion:'',
      tituloHotel:'',
      tituloAereo:'',
      tituloTerrestre:'',
      tituloTurismo:'',
      tituloEducativa:'',
      tituloNocturna:'',
    };
  },
  methods: { 
    showModal(item) {
      this.elegido = item;
      this.$refs["modalSancion"].show();
    },
    hideModal() {
      this.$refs["modalSancion"].hide();
    },
    showModal_multa(item) {
      this.elegido = item;
      this.$refs["modalMulta"].show();
    },
    hideModal_multa() {
      this.$refs["modalMulta"].hide();
    },

    async registrarSancion(elegido) {
      let ufv_valor=this.listado_ufv.monto
      this.id_persona_multa=elegido;
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        observacion_sancion: this.elegido.observacion_sancion,
        multa: this.multa,
        valor_multa_ufv:this.valor_multa_ufv,
        valor_multa_bs:ufv_valor*this.valor_multa_ufv,
        //pago:this.pago, 
      };
      
      try {
        this.resultados = await this.axios.put(`/updateMultaPersona`, data);
        this.registros = this.resultados.data.contenido;
        
        this.hideModal();
        this.$swal({
          title: "<strong>SANCION Registrada</strong>",
          type: "success",
          html: `la sanción fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
      
        this.AnalisisbusquedaPersona(this.parametro);
    
         //this.obtenerDocumento(this.id_persona_multa);
        
      } catch (error) {
        console.log(error);
      }
    },
    async registrarMulta(elegido) {
      this.id_persona_multa=elegido;
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        //deposito: this.elegido.deposito,
        deposito: this.elegido.deposito,
        fecha_deposito: this.fecha_deposito,
        pago:this.pago, 
      };
      try {
        this.resultados = await this.axios.put(`/MultaPersonaDeposito`, data);
        this.registros = this.resultados.data.contenido;
        
        this.hideModal_multa();
        this.$swal({
          title: "<strong>SANCION Registrada</strong>",
          type: "success",
          html: `la sanción fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        this.AnalisisbusquedaPersona(this.parametro);
        
        //this.obtenerTalon(this.id_persona_multa);
      } catch (error) {
        console.log(error);
      }
    },
    async registrosMultadosPersona(id_persona_multa) {

      try { 
          let resultados = await this.axios.get(`/personasMultadas/${id_persona_multa}`);
          this.registrosMultados = resultados.data.contenido;
            this.tituloDeclaracion = `Personas que no declararon `;        
      }
      catch (error) {
        console.log('catch: ', error);
      }
    },
        async listaUfv() {
       
        let fecha=moment(this.fecha_ufv).format("YYYY-MM-DD")
        
      try { 
          let resultados = await this.axios.get(`/lista_ufv/${fecha}`);
          this.listado_ufv = resultados.data.contenido;
          //console.log("ufv:",this.listado_ufv);
                if(this.listado_ufv == undefined || this.listado_ufv == 0 || this.listado_ufv == ''){
            this.$swal({
        title: "Cargar UFVs",
        html: "Porfavor!!!!",
        type: "warning",
     
        confirmButtonColor: "#3085d6",
        confirmButtonText: 'Aceptar'
      })
          }
      }
      catch (error) {
        console.log('catch: ', error);
      }
    },
    async registrosVencidosPersona() {
      try { 
          let resultados = await this.axios.get(`/personasVencidas`);
          this.registrosVencidos = resultados.data.contenido;
            this.tituloHotel = `Personas que vencieron su declaración `;        
      }
      catch (error) {
        console.log('catch: ', error);
      }
    },
    
    async AnalisisbusquedaPersona(parametro) {
  
      try { 
                       
        if(parametro!==''){ 
          let resultados = await this.axios.get(`/buscarPersonasMultadas/${this.parametro}`);
          this.registrosMultados = resultados.data.contenido;
        }
        if(parametro==''){
          this.registrosMultados='';
         }        
      }
      catch (error) {
        console.log('catch: ', error);
      }
    },
   async obtenerDocumento(item){
    
 let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(this.url_ac+item, config);
      
       await this.crearDescarga(resultados, 'reporte.pdf');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async obtenerTalon(item){
    
 let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(this.url+item, config);
      
       await this.crearDescarga(resultados, 'reporte.pdf');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    Limpiar() {
     this.registrosHotel="",
     this.registrosDeclarados="",
      this.registrosHotel="",
      this.registrosAviacion="",
      this.registrosTerrestre="",
      this.registrosTurismo="",
      this.registrosEstudiante="",
      this.registrosNocturno="" 
    },
    
 
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
  },
  created() {
   //this.registrosMultadosPersona(this.elegido);
    //this.registrosVencidosPersona()
    this.listaUfv();

  },
};
</script>
